import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Glyphicon, Nav, Navbar, NavItem, Form, Button, FormControl } from 'react-bootstrap';
import { LinkContainer } from 'react-router-bootstrap';
import './NavMenu.css';
import { ContentHeight } from './Variables';
import { Website } from '../BaseUrl';

export class NavMenu extends Component {
    displayName = NavMenu.name
    constructor(props) {
        super(props);
        this.state = {
            logo: this.props.logo
        }
    }    

    componentDidUpdate(prevProps) {
        if (prevProps.logo != this.props.logo ) {
            this.setState({
                logo: this.props.logo
            });
        }
    }

    render() {
        var logoUrl = null;
        if (this.state.logo == "default" || !this.props.LoggedIn) {
            logoUrl = require('../images/logo-white-sml.png');
        } 
        return (
            <Navbar className="page-headContainer" expand="xs" inverse collapseOnSelect>
            <div className="container">
                 <Navbar.Header>
                    <Navbar.Toggle />
                    <Navbar.Brand>
                        <a href={Website} style={{ textAlign: "center", padding: "3px" }} >
                            {(logoUrl != null) ? <img style={{ margin: "0 auto", maxWidth: "150px", maxHeight: "100%" }} src={logoUrl} /> : <span style={{fontSize: "38px", color: "#fff"}} className={this.state.logo}></span> }
                        </a>
                    </Navbar.Brand>
                </Navbar.Header>
                <Navbar.Collapse>
                        {
                            this.props.LoggedIn ?
                            <Nav>
                                <LinkContainer to={'/'} exact>
                                    <NavItem> Home </NavItem>
                                </LinkContainer>

                                <LinkContainer to={'/details'}>
                                    <NavItem> Your Details </NavItem>
                                </LinkContainer>

                                <LinkContainer to={'/Repayments'}>
                                    <NavItem> Repayments </NavItem>
                                </LinkContainer>
                        
                                <LinkContainer to={'/Statements'}>
                                    <NavItem> Your Statements </NavItem>
                                </LinkContainer>

                                <LinkContainer to={'/Agreements'}>
                                    <NavItem> Agreements </NavItem>
                                </LinkContainer>                        
                                <NavItem style={{ backgroundColor: "rgba(0, 120, 169, 0.77)" }} onClick={() => this.props.Logout()}> Log Out </NavItem>
                            </Nav>

                                :

                            <Nav>
                                <NavItem style={{ backgroundColor: "rgba(0, 120, 169, 0.77)" }} onClick={() => this.props.history.push("/Login")}> Login </NavItem>
                            </Nav>
                        }

                </Navbar.Collapse>
            </div>
        </Navbar>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/NavMenu.js